import React, { useState } from 'react';
import { ChannelBadge, ScoreBadge } from '../common/Badge';
import { formatDate } from '../../utils/formatters';
import { Eye, Edit3, Trash2 } from 'lucide-react';
import { EditLeadModal } from './EditLeadModal';

export function LeadTable({
  leads = [],
  onSelectLead,
  onUpdateStatus,
  onUpdateAssignee,
  onUpdateLead,
  onDeleteLead,
  showToast
}) {
  const [editingLead, setEditingLead] = useState(null);

  return (
    <>
      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <div className="table-responsive">
          <table className="custom-table">
            <thead>
              <tr>
                <th>Lead Info</th>
                <th>Channel</th>
                <th>Requirement</th>
                <th>Budget</th>
                <th>Score</th>
                <th>Status</th>
                <th>Assigned To</th>
                <th>Last Activity</th>
                <th style={{ textAlign: 'right' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {leads.map((lead) => (
                <tr key={lead.id}>
                  <td onClick={() => onSelectLead(lead)} style={{ cursor: 'pointer' }}>
                    <div style={{ fontWeight: 600, color: 'var(--text-main)' }}>{lead.name}</div>
                    <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>{lead.company}</div>
                    <div style={{ fontSize: '0.6875rem', color: 'var(--text-subtle)', fontFamily: 'var(--font-mono)' }}>{lead.id}</div>
                  </td>
                  <td>
                    <ChannelBadge channel={lead.channel} />
                  </td>
                  <td>
                    <div style={{ fontSize: '0.8125rem' }}>{lead.propertyType || '-'}</div>
                    <div style={{ fontSize: '0.725rem', color: 'var(--text-muted)' }}>{lead.space || ''}</div>
                  </td>
                  <td>{lead.budget || '-'}</td>
                  <td>
                    <ScoreBadge score={lead.score} />
                  </td>
                  <td>
                    <select
                      value={lead.status}
                      onChange={(e) => onUpdateStatus(lead.id, e.target.value)}
                      style={{
                        border: 'none',
                        background: 'transparent',
                        cursor: 'pointer',
                        fontSize: '0.8125rem',
                        fontWeight: 600,
                        outline: 'none'
                      }}
                    >
                      <option value="new">NEW</option>
                      <option value="qualified">QUALIFIED</option>
                      <option value="contacted">CONTACTED</option>
                      <option value="site_visit">SITE VISIT</option>
                      <option value="proposal">PROPOSAL</option>
                      <option value="leased">LEASED</option>
                      <option value="lost">LOST</option>
                    </select>
                  </td>
                  <td>
                    <select
                      value={lead.assignedTo || 'TBS Sales Team'}
                      onChange={(e) => onUpdateAssignee(lead.id, e.target.value)}
                      style={{
                        border: '1px solid var(--border-color)',
                        borderRadius: 'var(--radius-sm)',
                        padding: '4px 8px',
                        fontSize: '0.75rem',
                        backgroundColor: '#FAFAFC',
                        outline: 'none',
                        cursor: 'pointer'
                      }}
                    >
                      <option value="TBS Sales Team">TBS Sales Team</option>
                      <option value="TBS Specialist">TBS Specialist</option>
                      <option value="TBS Account Executive">TBS Account Executive</option>
                    </select>
                  </td>
                  <td>
                    <span style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>{formatDate(lead.lastActivity)}</span>
                  </td>
                  <td style={{ textAlign: 'right' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '6px' }}>
                      {/* View Details Icon */}
                      <button
                        onClick={() => onSelectLead(lead)}
                        title="View Details"
                        style={{ padding: '6px', borderRadius: 'var(--radius-sm)', border: '1px solid var(--border-color)', background: '#FFF', cursor: 'pointer', color: 'var(--text-muted)' }}
                      >
                        <Eye size={14} />
                      </button>

                      {/* Edit Lead Icon */}
                      <button
                        onClick={() => setEditingLead(lead)}
                        title="Edit Lead Details"
                        style={{ padding: '6px', borderRadius: 'var(--radius-sm)', border: '1px solid #A6E4FB', background: '#EBF8FC', cursor: 'pointer', color: '#1e92c4' }}
                      >
                        <Edit3 size={14} />
                      </button>

                      {/* Delete Lead Icon */}
                      {onDeleteLead && (
                        <button
                          onClick={() => {
                            if (window.confirm(`Delete lead ${lead.company}?`)) {
                              onDeleteLead(lead.id);
                            }
                          }}
                          title="Delete Lead"
                          style={{ padding: '6px', borderRadius: 'var(--radius-sm)', border: '1px solid #FCA5A5', background: '#FEF2F2', cursor: 'pointer', color: '#DC2626' }}
                        >
                          <Trash2 size={14} />
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Edit Lead Modal */}
      <EditLeadModal
        isOpen={Boolean(editingLead)}
        onClose={() => setEditingLead(null)}
        lead={editingLead}
        onUpdateLead={onUpdateLead}
        showToast={showToast}
      />
    </>
  );
}
